import {useTrackScreenVisit} from "crqlar-react-common/dist/utils/analytics.util";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {
    ServerTable,
    ServerTableColumns,
    ServerTableFilter,
    ServerTableFrame,
    ServerTableFullscreen,
    ServerTablePrint,
    ServerTableProvider,
    ServerTableSearch,
    ServerTableSort,
    ServerTableToolbar,
} from "../../common/serverTable";
import SettingsListPage from "../../system/layout/SettingsListPage";
import {SURVEY_SUBMISSIONS_TABLE_ID} from "../shared/surveyQueryRefresh";
import {SurveySubmissionsExport} from "./export/SurveySubmissionsExport";
import {SurveyListSubmissionDialog} from "./SurveyListSubmissionDialog";
import {useSurveySubmissionsList} from "./useSurveySubmissionsList";

/** Every submission ever collected; the period is a filter here, the module's review tab owns a date control. */
const SurveySubmissionsListPage = () => {
    useTrackScreenVisit('system survey submissions');

    const {t} = useTranslation();
    const navigate = useNavigate();

    const {controller, filterOptions, singleSurvey, selectedSubmission, nextOpenSubmissionId, openSubmission, closeSubmission} = useSurveySubmissionsList({
        tableId: SURVEY_SUBMISSIONS_TABLE_ID,
    });

    return (
        <SettingsListPage title={t('Submissions')} back={() => navigate('/system')}>
            <ServerTableProvider controller={controller}>
                <ServerTableFrame>
                    <ServerTableToolbar hoistOnCompact>
                        <ServerTableSearch placeholder={t('Search submissions')}/>
                        <ServerTableSort/>
                        <ServerTableFilter options={filterOptions}/>
                        <ServerTableFullscreen/>
                        <ServerTableColumns/>
                        <ServerTablePrint title={t('Submissions')}/>
                        <SurveySubmissionsExport survey={singleSurvey}/>
                    </ServerTableToolbar>

                    <ServerTable/>
                </ServerTableFrame>
            </ServerTableProvider>

            {!!selectedSubmission && (
                <SurveyListSubmissionDialog
                    submission={selectedSubmission}
                    onClose={closeSubmission}
                    nextOpenSubmissionId={nextOpenSubmissionId}
                    onOpenSubmission={openSubmission}
                />
            )}
        </SettingsListPage>
    );
};

export default SurveySubmissionsListPage;
